import React, { Component, Fragment, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { fromJS } from "immutable";
import CategoryVeritcalList from "containers/CategoryVerticalList";
import { ReactComponent as CrownIcon } from "assets/icons/Jackpot.svg";
import { ReactComponent as TrophyIcon } from "assets/icons/Tournament.svg";
import { ReactComponent as RibbonIcon } from "assets/icons/FreeRounds.svg";
import { ReactComponent as EditorsChoiceIcon } from "assets/icons/editors-badge.svg";
import { CategoryListItem } from "component/listItem";
import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { ReactComponent as PlayDemo } from "assets/icons/play-demo.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as Play } from "assets/icons/Play-Launch.svg";
import { ReactComponent as CashierIcon } from "assets/icons/cashInOut.svg";
import { ReactComponent as SwitchDevice } from "assets/icons/switchDevice.svg";
import bannerDefault from "assets/images/bannerDefault.png";
import { getTotalPool } from "utils/getTotalpool";
import { isEmpty } from "lodash";
import ShowMoreText from "react-show-more-text";
import { HAN_REGEX } from "utils/constants";
import { currencyFormatter } from "utils/currencyHelper";
import { withNamespaces } from "react-i18next";
import { renderWithBoldHelper } from "utils/renderWithBoldHelper";

import * as queryString from "query-string";

import "containers/GameAction/styles.scss";
import { setDefaultImageFormat } from "utils/image";

const ACTION_MODAL = "ACTION_MODAL";

class GameAction extends Component {
  constructor(props) {
    super(props);

    this.modalRef = createRef();
    this.modalActionRef = createRef();

    this.onCloseClickHandler = this._onCloseClickHandler.bind(this);
    this.onExpandDetails = this._onExpandDetails.bind(this);
    this.onGameItemClickHandler = this._onGameItemClickHandler.bind(this);
    this.getDetails = this._getDetails.bind(this);
    this.fetchGameUrl = this._fetchGameUrl.bind(this);
    this.handleScroll = this._handleScroll.bind(this);
    this.fetchRelatedLinks = this._fetchRelatedLinks.bind(this);
    this.handleDescription = this._handleDescription.bind(this);
    this.onClickEventHandler = this._onClickEventHandler.bind(this);
    this.getTotalPool = getTotalPool.bind(this);

    this.state = {
      isLoading: true,
      isLoadingRelated: true,
      loadingGameRel: null,
      details: null,
      relatedLinks: null,
      similarLink: null,
      launchRealLink: null,
      launchDemoLink: null,
      realUrl: null,
      demoUrl: null,
      realLink: null,
      demoLink: null,
      expand: false,
      hasPromotionIcons: null,
      showCategoryLabel: false,
      expandDescription: false,
      jackpotPool: null,
    };
  }

  _getDetails(gameId) {
    this.setState({
      isLoading: true,
      isLoadingRelated: true,
      loadingGameRel: null,
      details: null,
      relatedLinks: null,
      similarLink: null,
      launchRealLink: null,
      launchDemoLink: null,
      realUrl: null,
      demoUrl: null,
      realLink: null,
      demoLink: null,
      expand: false,
      hasPromotionIcons: null,
      showCategoryLabel: false,
    });

    this.props
      .fetchGameDetailsUrl(gameId)
      .then((response) => {
        let link = fromJS(response);
        return this.props.fetchGameDetails(link);
      })
      .then((response) => {
        let details = fromJS(response.payload.data);
        let hasPromotionIcons =
          details.get("hasFreeRounds") ||
          details.get("partOfOnGoingTournament") ||
          details.get("isFeatured") ||
          details.get("isJackpot");
        this.setState({
          details,
          hasPromotionIcons,
        });
        return;
      })
      .then(() => {
        let realLink;

        try {
          realLink = this.state.details.get("links").find((link) => {
            return link.get("rel") === "launch.real";
          });
        } catch (err) {}
        this.setState({
          realLink,
        });
      })
      .then(() => {
        let demoLink;
        try {
          demoLink = this.state.details.get("links").find((link) => {
            return link.get("rel") === "launch.demo";
          });
          this.setState({
            demoLink,
          });
        } catch (err) {
          return;
        }
      })
      .then(() => {
        this.setState({
          isLoading: false,
          isLoadingRelated: false,
        });
        let relatedLink;
        try {
          relatedLink = this.state.details.get("links").find((link) => {
            return link.get("rel") === "related.links";
          });
          let params = {
            nav: this.props.nav,
          };

          return this.fetchRelatedLinks(relatedLink, params);
        } catch (err) {
          return;
        }
      })
      .then(() => {
        this.setState({
          isLoadingRelated: false,
        });
      });
  }

  _fetchRelatedLinks(link, params) {
    return this.props.fetchRelatedLinks(link, params).then((response) => {
      this.setState({
        relatedLinks: fromJS(response),
      });
    });
  }

  async _onClickEventHandler(link) {
    let url;
    const newWindow = window.open("", this.props.gameLaunchTarget); // Open immediately

    this.setState({
      loadingGameRel: link.get("rel"),
    });

    await this.fetchGameUrl(link);

    switch (link.get("rel")) {
      case "launch.real":
        url = this.state.realUrl;
        break;
      case "launch.demo":
        url = this.state.demoUrl;
        break;
      default:
        url = null;
        break;
    }

    if (url) {
      newWindow.location.href = url;
    } else {
      newWindow.close();
    }

    this.setState({
      loadingGameRel: null,
    });
  }

  _fetchGameUrl(link) {
    let params;
    let returnUrl;
    switch (this.state.details.get("launchTarget")) {
      case "_top":
      case "_self":
      case "_parent":
        let urlParams = new URLSearchParams(this.props.location.search);
        let redirectParams = new URLSearchParams();
        let url = `${this.props.location.pathname}?${urlParams.toString()}`;
        redirectParams.set("redirect", btoa(encodeURIComponent(url)));
        returnUrl = `${window.location.origin}/${
          this.props.match.params.locale
        }/${
          this.props.match.params.sessionId
        }/exit?${redirectParams.toString()}`;
        break;
      default:
        returnUrl = `${window.location.origin}/${
          this.props.match.params.locale
        }/${this.props.match.params.sessionId}/exit`;
        break;
    }
    params = {
      returnUrl,
    };

    if (this.props.appId) {
      params = {
        returnUrl: `${this.props.appId}://lobby`,
      };
    }

    return this.props
      .fetchGameUrl(link, params)
      .then((response) => {
        if (link.get("rel") === "launch.real") {
          this.setState({
            launchRealLink: link,
            realUrl: response.payload.data.url,
          });
        } else if (link.get("rel") === "launch.demo") {
          this.setState({
            launchDemoLink: link,
            demoUrl: response.payload.data.url,
          });
        }
        return response;
      })
      .catch((err) => {
        this.setState({
          loadingGameRel: null,
        });
      });
  }

  _onGameItemClickHandler(game, rel) {
    this.setState({
      loadingGameRel: null,
    });
    let gameId = game.get("gameId");
    let nav = this.props.link ? this.props.link.get("rel") : null;
    this.props.gameClick(gameId, rel, nav).then((response) => {
      if (response.location) {
        this.props.navigateTo(response.location);
      } else if (response.params) {
        this.props.setGameAction(response.params);
      }
    });
  }

  _onExpandDetails() {
    this.setState({
      expand: !this.state.expand,
    });
  }

  _onCloseClickHandler() {
    this.setState({
      expand: false,
    });
    this.props.fetchBalance();
    let search = queryString.parse(this.props.location.search);
    delete search.gameId;
    delete search.playType;
    delete search.nav;
    this.props.navigateTo(`${this.props.location.pathname}`);
  }

  componentDidMount() {
    if (this.props.gameId) {
      this.getDetails(this.props.gameId);
      //scroll to top
      this.props.showModal(ACTION_MODAL);
      this.setState({
        expand: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.gameActionDetails !== nextProps.gameActionDetails &&
      nextProps.gameActionDetails
    ) {
      if (nextProps.gameActionDetails === null) {
        this.props.hideModal(ACTION_MODAL);
        this.setState({
          expand: false,
        });
      } else {
        this.setState(nextProps.gameActionDetails);
        try {
          let relatedLink = nextProps.gameActionDetails.details
            .get("links")
            .find((link) => {
              return link.get("rel") === "related.links";
            });
          let params = {
            nav: nextProps.gameActionParams.get("nav"),
          };
          this.fetchRelatedLinks(relatedLink, params);
        } catch (err) {}

        this.props.showModal(ACTION_MODAL);
      }
    }

    if (nextProps.gameId !== this.props.gameId) {
      if (nextProps.gameId === undefined || nextProps.gameId === "undefined") {
        this.props.hideModal(ACTION_MODAL);
        this.setState({
          expand: false,
        });
      } else {
        if (
          !this.state.details ||
          this.state.details.getIn(["gameId"]) !== nextProps.gameId
        ) {
          this.getDetails(nextProps.gameId);
        }
        this.props.showModal(ACTION_MODAL);
      }
    }
    if (
      this.state.details &&
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.state.details.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.gameActionDetails !== prevProps.gameActionDetails &&
      this.props.gameActionDetails &&
      this.modalRef.current
    ) {
      this.modalRef.current.scrollTo(0, 0);
    }

    if (
      prevProps.gameId !== this.props.gameId &&
      this.props.gameId &&
      this.modalRef.current
    ) {
      this.modalRef.current.scrollTo(0, 0);
    }
  }

  _handleScroll(event) {
    const { scrollTop } = event.currentTarget;
    if (scrollTop !== 0) {
      this.setState({ showCategoryLabel: true });
    } else {
      this.setState({ showCategoryLabel: false });
    }
  }

  _handleDescription() {
    let btns = document.getElementsByClassName("description-clickable");
    if (btns.length > 1) {
      if (this.state.expandDescription) {
        btns[0].click();
      } else {
        btns[1].click();
      }
      this.setState({ expandDescription: !this.state.expandDescription });
    }
  }

  render() {
    if (!this.props.gameId || !this.props.isMobile || !this.props.playType)
      return null;

    const { t } = this.props;
    let params = {
      location: this.props.location,
      url: this.state.gameUrl,
      hideSplash: this.props.hideSplash,
      isMobile: this.props.isMobile,
      appId: this.props.appId,
      target: "_self",
    };

    return (
      <div
        className={`game-action modal ${
          this.props.gameId ? "show" : "d-none"
        } expand`}
        onClick={() => {
          if (this.state.loadingGameRel) return;
          this.props.clearGameAction();
        }}
      >
        <div
          className="modal-dialog nopadding"
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className="modal-content">
            <div
              className="modal-body"
              ref={this.modalRef}
              onScroll={this.handleScroll}
            >
              <div className="header-game-action row">
                <button className="col-auto">
                  <PreviousIcon onClick={this.props.history.goBack} />
                </button>
                <div className="col d-flex align-items-center">
                  {this.state.details && (
                    <span
                      className={`details-actions ${
                        this.state.hasPromotionIcons ? "promotional" : ""
                      } ${this.state.showCategoryLabel ? "fade-in" : ""}`}
                      ref={this.actionLabel}
                    >
                      {this.state.details.get("name")}
                    </span>
                  )}
                </div>
                {this.props.showCashier && (
                  <div
                    className="col-auto"
                    onClick={this.props.broadcastCashier}
                  >
                    <CashierIcon />
                  </div>
                )}
                {this.props.showSwitchDevice && (
                  <div
                    className="col-auto switch-icon"
                    onClick={() => {
                      this.props.broadcastSwitchDevice(
                        params,
                        this.props.gameId
                      );
                    }}
                  >
                    <SwitchDevice />
                  </div>
                )}
                <button className="col-auto">
                  <CloseIcon
                    onClick={this.onCloseClickHandler}
                    disabled={this.state.loadingGameRel !== null}
                  />
                </button>
              </div>
              <div className="header-game-action d-none">
                {this.state.details && (
                  <span
                    className={`details-actions ${
                      this.state.hasPromotionIcons ? "promotional" : ""
                    } ${this.state.showCategoryLabel ? "fade-in" : ""}`}
                    ref={this.actionLabel}
                  >
                    {this.state.details.get("name")}
                  </span>
                )}
                {this.props.showCashier && (
                  <div
                    className="col-auto"
                    onClick={this.props.broadcastCashier}
                  >
                    <CashierIcon />
                  </div>
                )}
                {this.props.showSwitchDevice && (
                  <div
                    className="col-auto switch-icon"
                    onClick={() => {
                      this.props.broadcastSwitchDevice(
                        params,
                        this.props.gameId
                      );
                    }}
                  >
                    <SwitchDevice />
                  </div>
                )}
                <CloseIcon onClick={this.onCloseClickHandler} />
              </div>
              <div className="image-spacer" />
              <div className="image-row-expand">
                {this.state.details && (
                  <img
                    className="img-fluid w-100"
                    src={`${setDefaultImageFormat(
                      this.state.details.getIn(["images", "bannerUrl"]) +
                        "width=450&theme=dark",
                      this.props.imageFormat.get("banner")
                    )}`}
                    alt={this.state.details.get("name")}
                  />
                )}
                {!this.state.details && (
                  <img
                    className="img-fluid w-100"
                    src={bannerDefault}
                    alt="default"
                  />
                )}
              </div>
              <div className="row">
                <div className="col">
                  <div className="info">
                    <div className="title">
                      {!this.state.details && (
                        <span className="dummy">XXXX XXXXXX</span>
                      )}

                      {this.state.details && this.state.details.get("name") && (
                        <Fragment>
                          {this.state.hasPromotionIcons && (
                            <span className="game-feature">
                              {this.state.details.get(
                                "partOfOnGoingTournament"
                              ) && (
                                <span className="game-feature-badge trophyIcon">
                                  <TrophyIcon
                                    color="rgba(255, 204, 0, 1)"
                                    selectedcolor=""
                                  />
                                </span>
                              )}
                            </span>
                          )}
                          <span>{this.state.details.get("name")}</span>
                        </Fragment>
                      )}
                    </div>
                    <div className="provider">
                      {!this.state.details && (
                        <span className="dummy">XXXXXXXX</span>
                      )}
                      {this.state.details &&
                        this.state.details.get("provider") && (
                          <span>{this.state.details.get("provider")}</span>
                        )}
                    </div>
                    <div className="provider jackpot-pool">
                      {!this.state.details && (
                        <span className="dummy">XXXXXXXX</span>
                      )}
                      {this.state.details &&
                        this.state.details.get("isJackpot") && (
                          <span className="game-feature-badge jackpotIcon">
                            <CrownIcon color="rgba(255, 204, 0, 1)" />
                            {renderWithBoldHelper(
                              t,
                              "totalJackpotPoolOf",
                              "amount",
                              this.getTotalPool(
                                this.state.jackpotPool,
                                this.state.details,
                                false
                              )
                            )}
                          </span>
                        )}
                      {this.state.details &&
                        this.state.details.get("totalFreePlayAmount") && (
                          <span className="game-feature-badge ribbonIcon">
                            <RibbonIcon color="rgba(255, 204, 0, 1)" />
                            {renderWithBoldHelper(
                              t,
                              "enjoyInFreePlay",
                              "amount",
                              currencyFormatter(
                                this.state.details.get("totalFreePlayAmount"),
                                { currency: this.props.currency }
                              )
                            )}
                          </span>
                        )}
                      {this.state.details &&
                        this.state.details.get("isFeatured") && (
                          <span className="game-feature-badge editorsChoiceIcon">
                            <EditorsChoiceIcon color="rgba(255, 204, 0, 1)" />
                            {t("editorsChoice")}
                          </span>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {this.state.isLoading && (
                    <div className="btn btn-secondary w-100 dummy">&nbsp;</div>
                  )}
                  {!this.state.isLoading &&
                    this.state.details &&
                    this.state.realLink && (
                      <button
                        className={`btn btn-danger w-100 ${
                          this.state.loadingGameRel === "launch.real"
                            ? "animate"
                            : ""
                        }`}
                        onClick={() => {
                          this.setState({
                            loadingGameRel: this.state.realLink.get("rel"),
                          });
                          switch (this.props.gameLaunchTarget) {
                            case "_top":
                            case "_self":
                            case "_parent":
                              let game = this.state.details;
                              let rel = this.state.realLink.get("rel");
                              this.onGameItemClickHandler(game, rel);
                              break;
                            default:
                              this.onClickEventHandler(this.state.realLink);
                              break;
                          }
                        }}
                        disabled={this.state.loadingGameRel !== null}
                      >
                        <span className="play-now-icon">
                          <Play />
                        </span>
                        &nbsp;
                        {t("playNow")}
                      </button>
                    )}

                  {this.state.isLoading && (
                    <div className="btn btn-secondary w-100 dummy">&nbsp;</div>
                  )}

                  {!this.state.isLoading &&
                    this.state.details &&
                    this.state.demoLink && (
                      <button
                        className={`btn btn-secondary w-100 ${
                          this.state.loadingGameRel === "launch.demo"
                            ? "animate"
                            : ""
                        }`}
                        onClick={() => {
                          this.setState({
                            loadingGameRel: this.state.demoLink.get("rel"),
                          });
                          switch (this.props.gameLaunchTarget) {
                            case "_top":
                            case "_self":
                            case "_parent":
                              let game = this.state.details;
                              let rel = this.state.demoLink.get("rel");
                              this.onGameItemClickHandler(game, rel);
                              break;
                            default:
                              this.onClickEventHandler(this.state.demoLink);
                              break;
                          }
                        }}
                        disabled={this.state.loadingGameRel !== null}
                      >
                        <span className="play-now-icon">
                          <PlayDemo />
                        </span>
                        &nbsp;{t("demoPlay")}
                      </button>
                    )}
                  {!this.state.isLoading &&
                    this.state.details &&
                    !this.state.realLink &&
                    !this.state.demoLink && (
                      <div className="no-gameplay">
                        {t("noAvailableGameplay")}
                      </div>
                    )}
                </div>
              </div>
              {!this.state.details && (
                <div className="description">
                  <span className="dummy">
                    XXXXXX XX XXXX XXXX XX XXXXXXX XXX XXXXXXX XXXXXXX
                  </span>
                </div>
              )}
              {this.state.details && this.state.details.get("description") && (
                <div
                  onClick={() => {
                    this.handleDescription();
                  }}
                >
                  <ShowMoreText
                    lines={3}
                    more={t("more")}
                    less=""
                    className={`description
                    ${
                      this.state.details.get("description").match(HAN_REGEX)
                        ? "han"
                        : ""
                    }`}
                    anchorClass="description-clickable"
                    onClick={this.executeOnClick}
                    expanded={false}
                    width={0}
                    truncatedEndingComponent={"...    "}
                  >
                    {this.state.details.get("description").match(HAN_REGEX)
                      ? this.state.details
                          .get("description")
                          .split("")
                          .join(" ")
                      : this.state.details.get("description")}
                  </ShowMoreText>
                </div>
              )}
              <table className={`tinfo`}>
                <tbody>
                  {!this.state.details && (
                    <tr className="trinfo">
                      <th>{t("type")}: </th>
                      <td>
                        <span className="dummy">XXXXXX XX XXXX</span>
                      </td>
                    </tr>
                  )}
                  {this.state.details && this.state.details.get("gameType") && (
                    <tr className="trinfo">
                      <th>{t("type")}: </th>
                      <td>{this.state.details.get("gameType")}</td>
                    </tr>
                  )}
                  {!this.state.details && (
                    <tr className="trinfo">
                      <th>{t("features")}: </th>
                      <td>
                        <span className="dummy">XXX XX XXXXX</span>
                      </td>
                    </tr>
                  )}
                  {this.state.details &&
                    this.state.details.get("specialFeatures") && (
                      <tr className="trinfo">
                        <th>{t("features")}: </th>
                        <td>
                          <span>
                            {this.state.details
                              .get("specialFeatures")
                              .join(", ")}
                          </span>
                        </td>
                      </tr>
                    )}
                  {!this.state.details && (
                    <tr className="trinfo">
                      <th>{t("themes")}: </th>
                      <td>
                        <span className="dummy">XXXX XXX XXXXXXXX</span>
                      </td>
                    </tr>
                  )}
                  {this.state.details && this.state.details.get("themes") && (
                    <tr className="trinfo">
                      <th>{t("themes")}: </th>
                      <td>
                        <span>
                          {this.state.details.get("themes").join(", ")}
                        </span>
                      </td>
                    </tr>
                  )}
                  {!this.state.details && (
                    <tr className="trinfo">
                      <th>{t("variance")}: </th>
                      <td>
                        <span className="dummy">XXX XX XXXXX</span>
                      </td>
                    </tr>
                  )}
                  {this.state.details && this.state.details.get("volatility") && (
                    <tr className="trinfo">
                      <th>{t("variance")}: </th>
                      <td>
                        <span>{this.state.details.get("volatility")}</span>
                      </td>
                    </tr>
                  )}
                  {!this.state.details && (
                    <tr className="trinfo">
                      <th>{t("releaseDate")}: </th>
                      <td>
                        <span className="dummy">XXX XX XXXXX</span>
                      </td>
                    </tr>
                  )}
                  {this.state.details && this.state.details.get("releaseDate") && (
                    <tr className="trinfo">
                      <th>{t("released")}: </th>
                      <td>
                        <span>{this.state.details.get("releaseDate")}</span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Fragment>
                <div className="horizontal-bar"> </div>
                {!this.state.relatedLinks && (
                  <Fragment>
                    <CategoryVeritcalList />
                    <CategoryVeritcalList />
                  </Fragment>
                )}
                {this.state.relatedLinks &&
                  this.state.relatedLinks.map((link, key) => {
                    if (
                      this.props.ownCategoryLink &&
                      link.get("rel") === this.props.ownCategoryLink.get("rel")
                    ) {
                      return null;
                    } else if (
                      this.props.ownCategoryGamesTotal === 1 &&
                      this.props.nav === link.get("rel")
                    ) {
                      return null;
                    }

                    return (
                      <CategoryVeritcalList
                        key={key}
                        match={this.props.match}
                        link={link}
                        navigateTo={(path) => {
                          let modalElem = this.modalRef.current;
                          modalElem.scrollTop = 0;
                          this.props.navigateTo(path);
                        }}
                        listItemComponent={CategoryListItem}
                        location={this.props.location}
                        latestBroadcast={this.props.latestBroadcast}
                      />
                    );
                  })}
              </Fragment>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let sessionId = state.security.get("sessionId");
  let isMobile = state.window.get("isMobile");
  let { gameId, playType, nav } = queryString.parse(ownProps.location.search);
  let currency = null;
  let latestBroadcast;

  try {
    latestBroadcast = state.serverSentEvent.getIn(["latestBroadcast"]);
  } catch (err) {}

  //app not yet initialized
  if (!sessionId || !isMobile) {
    return {};
  }
  let isRound = false;
  let showCashier;
  let showSwitchDevice;
  let gameLaunchTarget;
  let pType;
  try {
    pType =
      playType === "launch.real" || playType === "launch.demo"
        ? null
        : playType;
  } catch (err) {}
  try {
    gameLaunchTarget = state.links.get("gameLaunchTarget");
  } catch (err) {}
  try {
    isMobile = state.window.get("isMobile");
  } catch (err) {}

  try {
    showCashier = state.profile.get("showCashier");
  } catch (err) {}
  try {
    showSwitchDevice = state.profile.get("showSwitchDevice");
  } catch (err) {}
  try {
    if (
      nav.indexOf("home.recentlyplayed") > -1 ||
      nav.indexOf("play-it-again") > -1
    ) {
      isRound = true;
    }
  } catch (err) {}

  if (!isEmpty(state.links.get("currency"))) {
    currency = state.links.get("currency");
  }

  return {
    nav,
    isMobile,
    isRound,
    gameId,
    gameActionDetails: state.game.get("stateDetails"),
    gameActionParams: state.game.get("params"),
    showCashier,
    showSwitchDevice,
    gameLaunchTarget,
    playType: pType,
    imageFormat: state.window.get("imageFormat"),
    locale: state.config.getIn(["locale"]),
    latestBroadcast,
    currency: currency,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    fetchGameDetailsUrl: (gameId) => dispatchProps.fetchGameDetailsUrl(gameId),
    fetchGameDetails: (link, params) =>
      dispatchProps.fetchGameDetails(link, params),
    fetchGameUrl: (link, params) => dispatchProps.fetchGameUrl(link, params),
    fetchRelatedLinks: (route, params) =>
      dispatchProps.fetchRelatedLinks(route, params),
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    navigateTo: (path) => ownProps.history.push(`${path}`),
    showModal: (modal) => dispatchProps.showModal(modal),
    hideModal: (modal) => dispatchProps.hideModal(modal),
    fetchBalance: () => dispatchProps.fetchBalance(),
    clearGameAction: () => dispatchProps.clearGameAction(),
    onGameLaunch: (params) => dispatchProps.onGameLaunch(params),
    broadcastCashier: () => dispatchProps.broadcastCashier(),
    broadcastSwitchDevice: (params, gameId) =>
      dispatchProps.broadcastSwitchDevice(params, gameId),
    gameClick: (gameId, playType, nav) =>
      dispatchProps.gameClick(gameId, playType, nav),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withNamespaces("translation")(GameAction));
